import { isEmbed } from '@databases/modes';
import { type PanelKeyToPropsMapping } from '@databases/panel-types';

import PanelSizes from './sizes';
import { storage as panelPersistedStorage } from './storage';

export function createPanelStorageKey(panelKey: keyof PanelKeyToPropsMapping | null) {
  const isEmbedView = isEmbed();

  return `${isEmbedView ? 'embed' : 'confluence-content'}-${panelKey ?? 'no-panel'}`;
}

export function getDefaultPanelSize(
  sidebarType: 'sidebar' | 'devtools',
  storageKey: string
) {
  const layout = panelPersistedStorage.getItem(storageKey);

  return layout
    ? layout[PanelSizes[sidebarType].order - 1]
    : PanelSizes[sidebarType as keyof typeof PanelSizes].defaultSize;
}
